module.exports = __webpack_public_path__ + "img/detail_baohe.8db8487d.png";